import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  AgencyProfileAssignmentFieldsFragment,
  AgencyProfileFieldsFragment,
  AgencyProfileSummaryFieldsFragment,
  GetAgencyProfileAssignmentsDocument,
  GetAgencyProfileAssignmentsQuery,
  GetAgencyProfileAssignmentsQueryVariables,
  GetAgencyProfileCapabilityCatalogDocument,
  GetAgencyProfileCapabilityCatalogQuery,
  GetAgencyProfileCapabilityCatalogQueryVariables,
  GetAgencyProfileDocument,
  GetAgencyProfileQuery,
  GetAgencyProfileQueryVariables,
  GetAgencyProfilesDocument,
  GetAgencyProfilesQuery,
  GetAgencyProfilesQueryVariables
} from '~/api/graphql';

export const getAgencyProfiles = async () =>
  queryData<
    GetAgencyProfilesQuery,
    GetAgencyProfilesQueryVariables,
    AgencyProfileSummaryFieldsFragment[]
  >(
    client,
    { query: GetAgencyProfilesDocument, variables: {} },
    (data) => data?.agencyProfiles || []
  );

export const getAgencyProfileAssignments = async () =>
  queryData<
    GetAgencyProfileAssignmentsQuery,
    GetAgencyProfileAssignmentsQueryVariables,
    AgencyProfileAssignmentFieldsFragment[]
  >(
    client,
    { query: GetAgencyProfileAssignmentsDocument, variables: {} },
    (data) => data?.agencyProfiles || []
  );

export const getAgencyProfile = async (id: string) =>
  queryData<GetAgencyProfileQuery, GetAgencyProfileQueryVariables, AgencyProfileFieldsFragment>(
    client,
    { query: GetAgencyProfileDocument, variables: { id: id } },
    (data) => data?.agencyProfile
  );

export const getAgencyProfileCapabilityCatalog = async () =>
  queryData<
    GetAgencyProfileCapabilityCatalogQuery,
    GetAgencyProfileCapabilityCatalogQueryVariables,
    GetAgencyProfileCapabilityCatalogQuery['agencyProfileCapabilityCatalog']
  >(
    client,
    { query: GetAgencyProfileCapabilityCatalogDocument, variables: {} },
    (data) => data?.agencyProfileCapabilityCatalog
  );

export const loadAgencyProfiles: LoaderFunction = () =>
  loadQuery(getAgencyProfiles(), {
    suppressAuthErrors: true
  });

export const loadAgencyProfile: LoaderFunction = ({ params }) =>
  loadQuery(getAgencyProfile(params.id || ''));

export const loadAgencyProfileCapabilityCatalog: LoaderFunction = () =>
  loadQuery(getAgencyProfileCapabilityCatalog());

export const loadAgencyProfileAssignments: LoaderFunction = () =>
  loadQuery(getAgencyProfileAssignments(), { suppressAuthErrors: true });
